<form  [formGroup]="resetForm"  (ngSubmit)=" onReset();">
	<div *ngIf="!load">

    <div class="d-flex flex-column">
      <div class="container-input-animated">

      <input class="input-variant-animated" placeholder="e.g: calrissian@domain.com" type="email" email name="resetEmail" formControlName="email" required>
         <div style="min-height: 24px">
                <div
            *ngIf="
              resetForm.controls.email.invalid &&
              (resetForm.controls.email.dirty ||
                resetForm.controls.email.touched)
            "
          >
            <span
              class="s-sm booking"
              *ngIf="resetForm.controls.email.errors.required"
            >
              <!-- Por favor, inserte un correo electrónico. -->
              Por favor, introduzca un email.
            </span>
            <span
              class="s-sm booking"
              *ngIf="resetForm.controls.email.errors?.email"
            >
              <!-- Por favor, inserte un correo electrónico válido. -->
              Por favor, introduzca un email válido.
            </span>
          </div>
         </div>


      </div>

				<p class="pt-1 hero-login-text-description">Introduce la dirección de correo con la que te registraste y te enviaremos los datos de acceso.</p>

        <!-- <div *ngIf="resetEmail.invalid && (resetEmail.dirty || resetEmail.touched)">
						<span class="s-sm booking pl-3" *ngIf="r.errors.required">
							Por favor introduzca un email.
						</span>
						<span class="s-sm booking pl-3" *ngIf="r.errors.email">
							Por favor introduzca un email válido.
						</span>
				</div> -->




        <div class="col-12 pb-2 d-flex justify-content-center" *ngIf="turnstileEnabled">
					<app-turnstile
						[siteKey]="turnstileSiteKey"
						action="forgot-password"
						[invisibleUntilSubmit]="true"
						(verified)="onTurnstileVerified($event)"
						(expired)="onTurnstileExpired()"
						(errored)="onTurnstileError()">
					</app-turnstile>
				</div>

          <button
                type="submit"
                class="btn-login-animated"
                style="margin-top: 0px;"
                  (click)="confirmAction()"
          >
            <p>
              ENVIAR
            </p>
            <i class="bi bi-arrow-right"></i>
          </button>

          	<p class="mb-3 hero-login-text-description" style="margin-top: 40px;" >Si no estás registrado</p>
          <button
                type="button"
                style="margin-top: 0px;"
                class="btn-login-animated" #modalJoinus data-toggle="modal" data-target="#modalJoinus"
          >
            <p>
              REGISTRAR
            </p>
            <i class="bi bi-arrow-right"></i>
          </button>




    </div>


	</div>
  <div *ngIf="load">
    <div class="d-flex justify-content-center align-items-center" style="margin-top: 5%;">
      <div class="spinner-border spinner-border-sm text-white mr-2" role="status">

      </div>
      <!-- <p class="s-m"> Cargando... </p> -->
      <p class="text-white mb-0 font-weight-bold"> CARGANDO... </p>
    </div>
  </div>
</form>


<!-- Template del componente -->
<div class="modal" [ngClass]="{ 'show': showModal }">
  <div class="modal-dialog">
    <div class="modal-content">
      <!-- Encabezado del modal -->
      <div class="modal-header">
        <h5 class="modal-title mt-2 text-black">{{titleModal}}</h5>
        <!-- <button type="button" class="close" (click)="closeModal()">
          <span aria-hidden="true">&times;</span>
        </button> -->
      </div>
      <!-- Cuerpo del modal -->
      <div class="modal-body ">
        <p class="mb-1 text-black">{{message}}</p>
      </div>
      <!-- Pie del modal -->
      <div class="d-flex flex-end justify-content-end mr-3 mb-4">
        <!-- <button type="button" class="btn btn-secondary" (click)="closeModal()">Cerrar</button> -->
        <button type="button"
                class="btn-confirm-modal rounded-pill"
                [ngStyle]="{'background-color':getClientsSettingAppAuth?.clients_setting_global?.color_main_1}"
                (click)="confirmAction()">ACEPTAR
        </button>
      </div>
    </div>
  </div>
</div>
